/* eslint-disable react/prop-types */
import { Tag } from "antd";
import { TRAINING_STATUS_LABELS, TRAINING_STATUS_COLORS } from "../utils/trainingCatalog.constants";

/**
 * StatusTag Component
 * Displays status with appropriate color tag
 * @param {Object} props
 * @param {string} props.status - Status value (pending, verified, rejected)
 */
export default function StatusTag({ status }) {
  const label = TRAINING_STATUS_LABELS[status] || "-";
  const color = TRAINING_STATUS_COLORS[status] || "default";

  if (!status) {
    return <Tag>-</Tag>;
  }

  return <Tag color={color}>{label}</Tag>;
}
